export const customerClaimsColumns = [
  { key: 'createdAt', text: 'Date Created', width: '15%' },
  { key: 'name', text: 'Name', width: '20%' },
  { key: 'product', text: 'Product', width: '15%' },
  { key: 'periodYear', text: 'Year', width: '10%' },
  { key: 'principalAmount', text: 'Ending Balance', width: '18%' },
  { key: 'interest', text: 'Interest', width: '10%' },
  { key: 'interestAmount', text: 'Total Amount', width: '20%' },
  // { key: 'approvalStatus', text: 'Approval', width: '10%' },
  { key: 'options', text: '', width: '5%' }
];
